import { Axios } from 'axios'
import { RootState } from '@/store'
import { TaishakuTaishoKmkTypeType, Kamoku, OutputFundTypeType, TaishakuTaishoElementTypeType } from '@/repositories/keiei-joho/data'
import { ResponseTaishakuTaishoSetting, ResponseTaishakuTaishoSettingItem } from '@/repositories/keiei-joho/taishaku-taisho/data'

type PostItem = {
  kmkType: TaishakuTaishoKmkTypeType;
  elementType: TaishakuTaishoElementTypeType;
  positiveKmkList: Kamoku[];
  negativeKmkList: Kamoku[];
}
type PostParamItem = {
  items: PostItem[];
  outputFundType: OutputFundTypeType;
}

export interface TaishakuTaishoSettingRepository {
  checkCorporationInfoExists (): Promise<boolean>;
  list (): Promise<ResponseTaishakuTaishoSetting>;
  save (postParam: ResponseTaishakuTaishoSettingItem[], outputFundType: OutputFundTypeType): Promise<void>;
}

export class TaishakuTaishoSettingRepositoryImpl implements TaishakuTaishoSettingRepository {
  constructor (http: Axios, baseUrl: string, state: RootState) {
    this.http = http
    this.baseUrl = `${baseUrl}/taishaku-taisho/setting`
    this.state = state
  }

  private readonly http: Axios

  private readonly baseUrl: string

  private readonly state: RootState

  async checkCorporationInfoExists (): Promise<boolean> {
    const { data } = await this.http.get(`${this.baseUrl}/check-corporation`)
    return data
  }

  async list (): Promise<ResponseTaishakuTaishoSetting> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate

    const { data } = await this.http.get(
      this.baseUrl,
      {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      }
    )
    return data
  }

  async save (params: ResponseTaishakuTaishoSettingItem[], outputFundType: OutputFundTypeType): Promise<void> {
    const items: PostItem[] = params.map(p => ({
      kmkType: p.kmkType,
      elementType: p.elementType,
      positiveKmkList: p.positiveKmkSettings.targets,
      negativeKmkList: p.negativeKmkSettings.targets
    }))
    const postParam: PostParamItem = {
      items: items,
      outputFundType
    }
    await this.http.post(this.baseUrl, postParam)
  }
}
